// extracted by mini-css-extract-plugin
module.exports = {"main":"infomap_main__m_10f","map":"infomap_map__2jjU5"};